/*
 *   File : loader.js
 *   Author : https://evoqins.com
 *   Description :  Loader component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

const Loader = (props) => {
    return (
        <div className={`${props.className} ${props.height ?? "h-100vh "} d-flex flex-column align-items-center justify-content-center py-5`}>
            {/* <img src={require("../../Assets/loader-dark.gif")}
                width={32}
                alt='loader' /> */}
            <div className="spinner center">
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
            </div>
        </div>
    )
}

export default memo(Loader);
